var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1494",
    style: {
      enableBackground: "new 0 0 1500 1494"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M812.2,45c117.1-0.9,175.5,73.6,155.9,189.2c-17.2,101.3-63.1,190-122.4,272C734,660.7,599,791.1,433.9,888.2 c-80.6,47.4-166.6,77-262.3,64.6C93,942.7,50.4,897.4,51.2,817.7c0.4-39.8,3.7-82.4,18.1-118.8C194,386.1,413.3,169.5,733.1,58.1 c16.1-5.6,33.3-8.3,50.1-11C795.3,45.1,807.6,45.3,812.2,45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.8,546c45.8,181.6,90.2,357.4,136.8,541.8c-180.7-58-354.7-113.8-535.3-171.8C638.2,791.8,767.6,671.5,902.8,546z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.8,1364.1c-72.7-140.5-144.2-278.6-219.4-423.8c183.9,59.3,360.9,116.5,543.6,175.4 C944.1,1214.1,839.3,1297,717.8,1364.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,1491.5c54-179.3,106.4-353.3,161.5-536.2c73.3,141.1,143.2,275.8,215.4,414.9 C580.3,1434.8,457.6,1476.2,320.3,1491.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.3,943.4c-53.1,176-104.6,346.6-158.2,524.3c-65.3-152.8-127.7-298.6-192-448.9C222.7,993.6,336.6,969.1,456.3,943.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.9,491c37.6-121.4,72.7-235.1,108.9-352.2c129.6,105.9,255.2,208.7,389.6,318.5C1262.8,468.8,1102.3,479.6,933.9,491z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314,783.9c-78.3,101.7-153,198.8-227.8,295.9c-3.4-1.6-6.9-3.1-10.3-4.7c-42.8-169.6-85.7-339.3-130.7-517.4 C1070.3,634.4,1188.8,707.1,1314,783.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.9,1367c93.1-76.2,182.5-150,273-222.4c7-5.6,26.5-6.2,32.8-0.6c99.6,86.7,198,174.8,294.9,270.1 C1178.2,1398.3,977.8,1382.6,777.9,1367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.7,1117c76.5-96.8,151.8-192.1,230.7-292c28,190.2,55.4,376.5,84.1,571.3C1302.8,1299.8,1199.3,1208,1096.7,1117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.2,521.8c164.2-11,328.3-22,505.6-33.9c-45.6,94-88,181.3-132.1,272.4c-130.7-80.2-253-155.3-375.4-230.3 C963.9,527.2,964.5,524.5,965.2,521.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.5,135c123.4,17.1,246.7,35.1,370.2,50.5c30.1,3.7,37.2,21.8,36.1,44.4c-3.4,72.7-9.2,145.3-14.1,217.9 c-4.8,1.4-9.6,2.7-14.4,4.1c-126.9-103.8-253.8-207.5-380.7-311.3C1090.6,138.7,1091.6,136.8,1092.5,135z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.7,547.9c-18.4,240.5-36.8,480.4-55.2,720.4c-2,0.1-4.1,0.1-6.1,0.2c-13.2-89.4-26.5-178.8-39.7-268.2 c-9-60.6-19.8-120.9-25.8-181.8c-2.1-21.1,3.3-45.7,13.1-64.7C1404.9,684.5,1444.2,617,1482.7,547.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.5,1069c56.4,137.2,112.8,274.4,174.3,424c-49.8-9.1-91-11.9-129-24.5c-64.2-21.4-81.2-50.1-76.4-116.3 c6.8-93.9,15.3-187.8,23.1-281.6C98.1,1070,100.8,1069.5,103.5,1069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1481.7,167.6c-133.1-18.7-264.9-37.1-407.6-57.1c48.7-27.2,91.1-47,129.2-73.1c48.5-33.3,94.9-40.6,149.4-14.1 C1418.9,55.5,1465.8,103.2,1481.7,167.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4,1479.2c61.7-28.7,120.9-56.9,180.8-83.4c10.4-4.6,23.9-4.2,35.7-3.3c147.4,11.6,294.8,23.7,442.1,35.7 c5.8,0.5,11.4,1.9,16.9,5.7C982.7,1448.9,758.5,1463.9,531.4,1479.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.7,1c106.9,0,204.7,0,302.5,0c0.7,2.2,1.3,4.4,2,6.6c-51.6,28.7-103,57.7-155.2,85.5c-5.4,2.9-16.4,0.3-22.2-3.7 C982.5,62.2,942.9,33.9,895.7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,1134.5c0-97.7,0-192.7,0-287.7c3.5-0.7,7.1-1.3,10.6-2c19.3,50.3,39,100.4,57.6,150.9c2.1,5.8-0.1,14.8-3.3,20.7 C48.8,1055.7,27,1094.5,4.9,1134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,1375.7c-59.5-104.6-54.8-196.4,23.7-284.3C57.4,1184.5,49.8,1275.7,41.5,1375.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.60ca75f69cd83c6c6887e94868a1c78d.svg";
export { ForwardRef as ReactComponent };